export default "__VITE_ASSET__BSoNfb5E__"